import React, { ReactNode } from 'react';
import Alert from './index';

export default function AlertProvider(props: { children: ReactNode }): JSX.Element {
  const [popup, setPopup] = React.useState<JSX.Element[]>([]);
  Alert.setProvider(setPopup);
  const { children } = props;
  return (
    <>
      {popup}
      {children}
    </>
  );
}
